import { Box, Typography, Stack, Grid, useTheme } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { createPrefixedPropsFilteredComponent } from 'helpers/styledHelpers';

const StyledAnswerTypography = createPrefixedPropsFilteredComponent<{ $isChosenAnswer: boolean }>(Typography)(({ $isChosenAnswer }) => ({
  fontWeight: $isChosenAnswer ? 'bold' : 'normal'
}));

const StyledArrowIcon = createPrefixedPropsFilteredComponent<{ $isChosenAnswer: boolean }>(ArrowForwardIcon)(({ $isChosenAnswer }) => ({
  visibility: $isChosenAnswer ? 'visible' : 'hidden'
}));

interface SelectedAnswerProps {
    answer: string;
    index: number;
    score: number;
    isChosenAnswer: boolean;
}

const SelectedAnswer: React.FC<SelectedAnswerProps> = ({  answer, index, score, isChosenAnswer }) => {
    const theme = useTheme();
    
    return (
        <Box key={index} width={'100%'} maxWidth={'100%'} display={'flex'} flexDirection={'row'}>
            <Grid item xs={9} width={'100%'}>
                <Stack display={'flex'} flexDirection={'row'} width={'100%'}>
                    <Box width={theme.spacing(5)} display={'flex'} flexDirection={'row'}>
                        <Box>
                            <StyledArrowIcon $isChosenAnswer={isChosenAnswer} />
                        </Box>
                        <Typography marginRight={theme.spacing(1)}>{index + 1}. </Typography>                        
                    </Box>                 
                    <StyledAnswerTypography color={score > 0 ? 'green' : 'red'} $isChosenAnswer={isChosenAnswer}>
                        {answer}
                    </StyledAnswerTypography>   
                </Stack>  
            </Grid>
            <Grid item xs={3}>
                <Typography marginLeft={theme.spacing(1)} color={score > 0 ? 'green' : 'red'}>
                    {score} 
                </Typography>
            </Grid>                        
        </Box>
        
    );
}

export default SelectedAnswer;